import { Routes, Route, Navigate } from 'react-router-dom';
import PlatformApp from '@/platform/PlatformApp.jsx';
import TenantActivation from '@/platform/TenantActivation.jsx';
import AppLayout from '@/AppLayout.jsx';
import Placeholder from '@/pages/Placeholder.jsx';
import EmisionGuiaV3 from '@/pages/guias/EmisionGuiaV3.jsx';
import GuiasListado from '@/pages/guias/GuiasListado.jsx';
import GuiasBuscar from '@/pages/guias/GuiasBuscar.jsx';
import EmisionFoja from '@/pages/Fojas/EmisionFoja.jsx';
import RecepcionFoja from '@/pages/Fojas/RecepcionFoja.jsx';
import RecepcionOperativa from '@/pages/Cargas/RecepcionOperativa.jsx';
import PrivateRoute from '@/routes/PrivateRoute.jsx';
import AltaCliente from '@/pages/clientes/AltaCliente.jsx';
// Nuevo componente de Alta de Cliente con pestañas
import NuevoCliente from '@/pages/clientes/NuevoCliente/index.jsx';
import CuentaCorrienteCliente from '@/pages/clientes/CuentaCorriente.jsx';
import CreditoCliente from '@/pages/clientes/CreditoCliente.jsx';
import CreditosDashboard from '@/pages/finanzas/CreditosDashboard.jsx';
import TarifariosPage from '@/pages/finanzas/TarifariosPage.jsx';
import FacturaManual from '@/pages/facturacion/FacturaManual.jsx';
import FacturacionIndex from '@/pages/facturacion/FacturacionIndex.jsx';
import FacturacionNueva from '@/pages/facturacion/FacturacionNueva.jsx';
import FacturaDetalle from '@/pages/facturacion/FacturaDetalle.jsx';
import FacturaPrintConfig from '@/pages/facturacion/FacturaPrintConfig.jsx';
import ListadoProveedores from '@/pages/Admin/Proveedores/ListadoProveedores.jsx';
import NuevoProveedor from '@/pages/Admin/Proveedores/NuevoProveedor.jsx';
import EditarProveedor from '@/pages/Admin/Proveedores/EditarProveedor.jsx';
import ListadoCompras from '@/pages/Tesoreria/Compras/ListadoCompras.jsx';
import NuevaCompra from '@/pages/Tesoreria/Compras/NuevaCompra.jsx';
import VerEditarCompra from '@/pages/Tesoreria/Compras/VerEditarCompra.jsx';
import CargaMasivaCompras from '@/pages/Tesoreria/Compras/CargaMasivaCompras.jsx';
import DashboardTesoreria from '@/pages/Tesoreria/DashboardTesoreria.jsx';
// Tesorería - Cuentas Bancarias
import ListadoCuentas from '@/pages/Tesoreria/Cuentas/ListadoCuentas.jsx';
import EditarCuenta from '@/pages/Tesoreria/Cuentas/EditarCuenta.jsx';
// Tesorería - Medios de Pago
import ListadoMediosPago from '@/pages/Tesoreria/MediosPago/ListadoMediosPago.jsx';
import EditarMedioPago from '@/pages/Tesoreria/MediosPago/EditarMedioPago.jsx';
// Tesorería - Pagos
import ListadoPagos from '@/pages/Tesoreria/Pagos/ListadoPagos.jsx';
import EditarPago from '@/pages/Tesoreria/Pagos/EditarPago.jsx';
import CuentasAPagar from '@/pages/Tesoreria/Pagos/CuentasAPagar.jsx';
import MinutasPago from '@/pages/Tesoreria/Pagos/MinutasPago.jsx';
// Tesorería - Cobranzas
import ListadoCobranzas from '@/pages/Tesoreria/Cobranzas/ListadoCobranzas.jsx';
import RegistrarCobranza from '@/pages/Tesoreria/Cobranzas/RegistrarCobranza.jsx';
import ReciboDetalle from '@/pages/Tesoreria/Cobranzas/ReciboDetalle.jsx';
import ListadoRecibos from '@/pages/Tesoreria/Cobranzas/ListadoRecibos.jsx';
import CarteraCheques from '@/pages/Tesoreria/Cobranzas/CarteraCheques.jsx';
import EditarCobranza from '@/pages/Tesoreria/Cobranzas/EditarCobranza.jsx';
import MinutasList from '@/pages/Tesoreria/Cobranzas/MinutasList.jsx';
import MinutaUnificadaDetalle from '@/pages/Tesoreria/Cobranzas/MinutaUnificadaDetalle.jsx';
import SeguimientoContrareembolsos from '@/pages/Tesoreria/Cobranzas/SeguimientoContrareembolsos.jsx';
import ContrareembolsoDetalle from '@/pages/Tesoreria/Cobranzas/ContrareembolsoDetalle.jsx';
// Cobranzas - Minutas
import CobranzasHome from '@/pages/Cobranzas/CobranzasHome.jsx';
import AbrirMinuta from '@/pages/Cobranzas/AbrirMinuta.jsx';
import MinutaDetalle from '@/pages/Cobranzas/MinutaDetalle.jsx';
import CerrarMinuta from '@/pages/Cobranzas/CerrarMinuta.jsx';
// Tesorería - Conciliaciones
import Conciliaciones from '@/pages/Tesoreria/Conciliaciones/Conciliaciones.jsx';
import CajasPage from '@/pages/Tesoreria/Caja/CajasPage.jsx';
import CajaDetallePage from '@/pages/Tesoreria/Caja/CajaDetallePage.jsx';
import LiquidacionesChoferesPage from '@/pages/Tesoreria/Choferes/LiquidacionesChoferesPage.jsx';
import LiquidacionChoferDetallePage from '@/pages/Tesoreria/Choferes/LiquidacionChoferDetallePage.jsx';
import { routes } from '@/routes/map.js';
import { guiasRoutes } from '@/router/routes-guias.js';
import { authRoutes } from '@/router/routes-auth.js';
import { useAuth } from '@/state/auth/AuthContext.jsx';
import { adminRoutes } from '@/modules/administracion/admin.routes.js';
import NumeracionesPage from '@/modules/administracion/numeraciones/NumeracionesPage.jsx';
import ClientesList from '@/modules/administracion/clientes/ClientesList.jsx';
import { rrhhRoutes } from '@/router/routes.js';
import ListaChoferes from '@/pages/Administracion/Choferes/ListaChoferes.jsx';
import CrearChofer from '@/pages/Administracion/Choferes/CrearChofer.jsx';
import VerChofer from '@/pages/Administracion/Choferes/VerChofer.jsx';
import EditarChofer from '@/pages/Administracion/Choferes/EditarChofer.jsx';
import DashboardAdministracion from '@/pages/Administracion/Dashboard/index.js';
import EnConstruccion from '@/pages/Administracion/EnConstruccion.jsx';
import ListadoUnidades from '@/pages/Administracion/Flota/Listado.jsx';
import FormularioUnidad from '@/pages/Administracion/Flota/Formulario.jsx';
import ListadoAsignacionesFlota from '@/pages/Administracion/FlotaAsignaciones/Listado.jsx';
import NuevaAsignacionFlota from '@/pages/Administracion/FlotaAsignaciones/Nueva.jsx';
import { DashboardCargas } from '@/pages/Cargas';
import MantenimientoFlotaListado from '@/pages/MantenimientoFlota/Listado.js';
import MantenimientoFlotaFormulario from '@/pages/MantenimientoFlota/Formulario.js';
import RepartosListado from '@/pages/Repartos/Listado.jsx';
import RepartoNuevo from '@/pages/Repartos/Nuevo.jsx';
import RepartoDetalle from '@/pages/Repartos/Detalle.jsx';
import RepartosEstadisticas from '@/pages/Repartos/Estadisticas.jsx';
import TarifasPage from '@/pages/Tarifas/index.jsx';
import RetirosPage from '@/pages/Retiros/index.jsx';
import EtiquetasListado from '@/pages/Cargas/EtiquetasListado.jsx';
import EtiquetasNueva from '@/pages/Cargas/EtiquetasNueva.jsx';
import RecepcionDetalle from '@/pages/Cargas/RecepcionDetalle.jsx';
import RecepcionList from '@/pages/Cargas/Recepcion/RecepcionList.tsx';
import RecepcionWizard from '@/pages/Cargas/Recepcion/RecepcionWizard.tsx';
import ControlCargaMonitor from '@/pages/Cargas/ControlCarga/ControlCargaMonitor.tsx';
import ControlBultos from '@/pages/Cargas/ControlBultos.jsx';
import EtiquetasZpl from '@/pages/Administracion/EtiquetasZpl.jsx';
import ListadoLineas from '@/pages/Lineas/ListadoLineas.jsx';
import NuevaLinea from '@/pages/Lineas/NuevaLinea.jsx';
import RetornablesMonitor from '@/pages/Retornables/RetornablesMonitor.jsx';
import DocumentacionPorBolsa from '@/pages/Retornables/DocumentacionPorBolsa.jsx';
import RetornablesTipos from '@/pages/Retornables/RetornablesTipos.jsx';
import ChatPage from '@/pages/Chat/ChatPage.jsx';

import ContabilidadCuentasPage from '@/pages/Contabilidad/Cuentas/index.jsx';
import ContabilidadCentrosPage from '@/pages/Contabilidad/Centros/index.jsx';
import ContabilidadAsientosPage from '@/pages/Contabilidad/Asientos/index.jsx';
import ContabilidadPoliticasPage from '@/pages/Contabilidad/Politicas/index.jsx';
import ContabilidadReportesPage from '@/pages/Contabilidad/Reportes/index.jsx';

import ProveedoresPage from '@/pages/Compras/Proveedores/index.jsx';
import OrdenesPage from '@/pages/Compras/Ordenes/index.jsx';
import RecepcionesPage from '@/pages/Compras/Recepciones/index.jsx';
import MovimientosPage from '@/pages/Stock/Movimientos/index.jsx';
import UbicacionesPage from '@/pages/Stock/Ubicaciones/index.jsx';
import InventariosPage from '@/pages/Stock/Inventarios/index.jsx';
import KardexPage from '@/pages/Stock/Kardex/index.jsx';
import TicketsPage from '@/pages/Atencion/Tickets/index.jsx';
import SlaPage from '@/pages/Atencion/SLA/index.jsx';
import AtencionDashboardPage from '@/pages/Atencion/Dashboard/index.jsx';
import PortalLoginPage from '@/pages/Portal/Login/index.jsx';
import PortalEnviosPage from '@/pages/Portal/Envios/index.jsx';
import PortalTicketNuevoPage from '@/pages/Portal/TicketNuevo/index.jsx';
import PortalTicketDetailPage from '@/pages/Portal/TicketDetail/index.jsx';
import StockDashboardPage from '@/pages/Stock/Dashboard/index.jsx';
import SeguridadHome from '@/pages/Seguridad/index.jsx';
import UsuariosList from '@/pages/Seguridad/Usuarios/List.jsx';
import RolesPermisosList from '@/pages/Seguridad/RolesPermisos/List.jsx';
import SesionesList from '@/pages/Seguridad/Sesiones/List.jsx';
import AuditoriaList from '@/pages/Seguridad/Auditoria/List.jsx';
import UsuarioSecurityForm from '@/pages/Seguridad/Usuarios/Form.jsx';
import RolSecurityForm from '@/pages/Seguridad/RolesPermisos/Form.jsx';
import RouteAccessGuard from '@/components/security/RouteAccessGuard.jsx';
import DashboardGerencial from '@/pages/Gerencial/DashboardGerencial.jsx';
import ExecutiveDashboardPage from '@/pages/Gerencial/ExecutiveDashboard.jsx';
import GerencialAlertasPage from '@/pages/Gerencial/Alertas.jsx';
import GerencialReportesPage from '@/pages/Gerencial/Reportes.jsx';
import FojasPoliticasPage from '@/pages/Gerencial/FojasPoliticasPage.jsx';
import DashboardOperativoReportesPage from '@/pages/Reportes/DashboardOperativo.jsx';
import InformesDashboard from '@/pages/Reportes/InformesDashboard.jsx';
import ReportesGerenciales from '@/pages/Gerencial/ReportesGerenciales.jsx';
import AlertasOperativasReportesPage from '@/pages/Reportes/AlertasOperativas.jsx';
import { clipperCargasRoutes } from '@/pages/Cargas/clipperPlaceholders.jsx';
import { clipperTesoreriaRoutes } from '@/pages/Tesoreria/clipperPlaceholders.jsx';
import { clipperCtasCtesRoutes } from '@/pages/CtasCtes/clipperPlaceholders.jsx';
import NovedadesPage from '@/pages/Cargas/NovedadesPage.jsx';
import NovedadesRetenidasPage from '@/pages/Cargas/NovedadesRetenidasPage.jsx';
import AlertasOperaciones from '@/pages/Operaciones/AlertasOperaciones.jsx';
import MonitorOperaciones from '@/pages/Operaciones/MonitorOperaciones.jsx';
import InteligenciaOperativa from '@/pages/Operaciones/InteligenciaOperativa.tsx';
import InteligenciaOperativaConfiguracion from '@/pages/Operaciones/InteligenciaOperativaConfiguracion.tsx';
import SucursalesEmpresaPage from '@/pages/Administracion/Empresa/SucursalesEmpresaPage.jsx';
import LocalidadesAtendidasPage from '@/pages/Administracion/Empresa/LocalidadesAtendidasPage.jsx';
import DiccionarioLocalidadesPage from '@/pages/Administracion/Geografia/DiccionarioLocalidadesPage.jsx';
import ActualizacionLocalidadesPage from '@/pages/Administracion/Geografia/ActualizacionLocalidadesPage.jsx';
import ProvinciasPage from '@/pages/Administracion/Geografia/ProvinciasPage.jsx';
import PaisesPage from '@/pages/Administracion/Geografia/PaisesPage.jsx';
import RutasDistribucionPage from '@/pages/Administracion/Empresa/RutasDistribucionPage.jsx';
import GuiaPrintTemplatePage from '@/pages/Administracion/Empresa/GuiaPrintTemplatePage.jsx';
import EmpresasRedespachoPage from '@/pages/Administracion/Empresa/EmpresasRedespachoPage.jsx';
import PuntosVentaPage from '@/pages/Administracion/Empresa/PuntosVentaPage.jsx';
import InvoiceEmailSettingsPage from '@/pages/Administracion/Empresa/InvoiceEmailSettingsPage.jsx';
import AfipCredentialsPage from '@/pages/Administracion/Empresa/AfipCredentialsPage.jsx';
import BancosPage from '@/pages/Administracion/BancosValores/BancosPage.jsx';
import ConceptosBancariosPage from '@/pages/Administracion/BancosValores/ConceptosBancariosPage.jsx';
import RetencionesValoresPage from '@/pages/Administracion/BancosValores/RetencionesValoresPage.jsx';
import ImpresionPage from '@/pages/Configuracion/ImpresionPage.jsx';
import { LegacyStockConsulta, LegacyStockMovimientoForm, LegacyStockMovimientos } from '@/pages/legacy-stock/LegacyStockPage.jsx';


export default function App() {
  const { isAuth } = useAuth();
  const platformHost = typeof window !== 'undefined' && window.location.hostname.toLowerCase().startsWith('admin.');
  const platformPath = typeof window !== 'undefined' && (window.location.pathname === '/admin' || window.location.pathname.startsWith('/admin/login') || window.location.pathname.startsWith('/admin/tenants'));
  if (platformHost || platformPath) return <PlatformApp />;
  
  const guiaEntries = guiasRoutes.reduce((acc, route) => {
    acc[route.path] = <route.component />;
    return acc;
  }, {});

  const adminRouteEntries = adminRoutes.reduce((acc, route) => {
    acc[route.path] = <route.component />;
    return acc;
  }, {});

  const rrhhRouteEntries = rrhhRoutes.reduce((acc, route) => {
    acc[route.path] = <route.component />;
    return acc;
  }, {});

  const adminPlaceholderRoutes = {
    '/administracion/maestros/actualizacion-de-cat': (
      <EnConstruccion title="Actualización de CAT" />
    ),
    '/administracion/maestros/empresas-de-transportes': (
      <EnConstruccion title="Empresas de transportes" />
    ),
    '/administracion/maestros/tipo-de-unidades': <EnConstruccion title="Tipo de unidades" />,
    '/administracion/maestros/parametros-para-las-unidades': (
      <EnConstruccion title="Parámetros para las unidades" />
    ),
    '/administracion/maestros/transportes-para-redespachos': <EmpresasRedespachoPage />,
    '/administracion/maestros/descripcion-de-envases': <RetornablesTipos />,
    '/tablas/descripcion-de-envases': <RetornablesTipos />,
    '/administracion/maestros/articulos-para-viajes': (
      <EnConstruccion title="Artículos para viajes" />
    ),
    '/administracion/maestros/conceptos-de-gastos-y-anticipos': (
      <EnConstruccion title="Conceptos de gastos y anticipos" />
    ),
    '/administracion/maestros/gastos-y-anticipos-predefinidos-por-cliente': (
      <EnConstruccion title="Gastos y anticipos predefinidos por cliente" />
    ),
    '/administracion/maestros/retornables': <EnConstruccion title="Retornables" />,
    '/administracion/maestros/clientes-eventuales-para-expreso': (
      <EnConstruccion title="Clientes eventuales para expreso" />
    ),
    '/administracion/maestros/tipos-de-servicios-de-viajes': (
      <EnConstruccion title="Tipos de servicios de viajes" />
    ),
    '/administracion/maestros/alertas-para-clientes': (
      <EnConstruccion title="Alertas para clientes" />
    ),
    '/administracion/maestros/choferes-y-transportes-inhabilitados': (
      <EnConstruccion title="Choferes y transportes inhabilitados" />
    ),
    '/administracion/maestros/documentos-para-caratula': (
      <EnConstruccion title="Documentos para carátula" />
    ),
    '/administracion/maestros/situacion-de-los-choferes': (
      <EnConstruccion title="Situación de los choferes" />
    ),
    '/administracion/maestros/unidades-de-medida': (
      <EnConstruccion title="Unidades de medida" />
    ),
    '/administracion/maestros/rubros-de-logistica': (
      <EnConstruccion title="Rubros de logística" />
    ),
    '/administracion/maestros/maestro-de-eventos-de-logistica': (
      <EnConstruccion title="Maestro de eventos de logística" />
    ),
    '/administracion/maestros/conceptos-de-valorizacion': <TarifasPage defaultTab="conceptos" />,
    '/administracion/maestros/estaciones-de-servicios': (
      <EnConstruccion title="Estaciones de servicios" />
    ),
    '/administracion/maestros/tipos-de-combustibles': (
      <EnConstruccion title="Tipos de combustibles" />
    ),
    '/administracion/maestros/marcas-de-combustibles': (
      <EnConstruccion title="Marcas de combustibles" />
    ),
    '/administracion/maestros/rubros': <EnConstruccion title="Rubros" />,
    '/administracion/maestros/motivos-de-inconvenientes': (
      <EnConstruccion title="Motivos de inconvenientes" />
    ),
    '/administracion/maestros/dias-no-laborables-feriados': (
      <EnConstruccion title="Días no laborables (Feriados)" />
    ),
    '/administracion/maestros/actualizacion-de-vendedores': (
      <EnConstruccion title="Actualización de vendedores" />
    ),
    '/administracion/maestros/actualizacion-de-cobradores': (
      <EnConstruccion title="Actualización de cobradores" />
    ),
    '/administracion/maestros/estados-de-los-comprobantes': (
      <EnConstruccion title="Estados de los comprobantes" />
    ),
    '/administracion/maestros/configurar-alertas-y-vencimientos': (
      <EnConstruccion title="Configurar alertas y vencimientos" />
    ),
    '/administracion/maestros/origenes-de-los-prospectos': (
      <EnConstruccion title="Orígenes de los prospectos" />
    ),
    '/administracion/maestros/actualizacion-de-recorridos': (
      <EnConstruccion title="Actualización de recorridos" />
    ),
    '/administracion/maestros/categorizacion-de-recorridos': (
      <EnConstruccion title="Categorización de recorridos" />
    ),
    '/administracion/maestros/zonas-tarifarias': (
      <EnConstruccion title="Zonas tarifarias" />
    ),
    '/administracion/maestros/porcentajes-por-zona-de-reparto': (
      <EnConstruccion title="Porcentajes por zona de reparto" />
    ),
    '/administracion/maestros/puestos-de-peajes': (
      <EnConstruccion title="Puestos de peajes" />
    ),
    '/administracion/maestros/concesionarios-de-peajes': (
      <EnConstruccion title="Concesionarios de peajes" />
    ),
    '/administracion/maestros/liquidacion-de-repartos': (
      <EnConstruccion title="Liquidación de repartos" />
    ),
    '/administracion/maestros/repartos-y-guias-a-liquidar': (
      <EnConstruccion title="Repartos y guías a liquidar" />
    ),
    '/administracion/maestros/reporte-de-guias-liquidadas-por-pdi': (
      <EnConstruccion title="Reporte de guías liquidadas por PDI" />
    ),
    '/administracion/geografia/actualizacion-de-localidades': <ActualizacionLocalidadesPage />,
    '/administracion/geografia/provincias': <ProvinciasPage />,
    '/administracion/geografia/paises': <PaisesPage />,
    '/administracion/geografia/diccionario-de-localidades': <DiccionarioLocalidadesPage />,
    '/administracion/tarifas/tarifas-para-almacen': <TarifasPage defaultTab="reglas" />,
    '/administracion/tarifas/tarifas-por-cliente-y-articulo': <TarifasPage defaultTab="reglas" />,
    '/administracion/tarifas/tarifas-para-clientes': <TarifasPage defaultTab="reglas" />,
    '/administracion/tarifas/tarifas-para-choferes-y-fleteros': <TarifasPage defaultTab="reglas" />,
    '/administracion/tarifas/consulta-de-tarifas-clientes-o-fleteros': <TarifasPage defaultTab="reglas" />,
    '/administracion/tarifas/numeradores-tarifarios': <TarifasPage defaultTab="numeradores" />,
    '/administracion/flota-y-taller/padron-de-cubiertas': (
      <EnConstruccion title="Padrón de cubiertas" />
    ),
    '/administracion/flota-y-taller/articulos-del-panol': (
      <EnConstruccion title="Artículos del pañol" />
    ),
    '/administracion/flota-y-taller/tipos-de-mantenimiento': (
      <EnConstruccion title="Tipos de mantenimiento" />
    ),
    '/administracion/flota-y-taller/tareas-para-mantenimiento': (
      <EnConstruccion title="Tareas para mantenimiento" />
    ),
    '/administracion/flota-y-taller/equipos-generales-y-maquinarias': (
      <EnConstruccion title="Equipos generales y maquinarias" />
    ),
    '/administracion/flota-y-taller/marcas-de-articulos-y-cubiertas': (
      <EnConstruccion title="Marcas de artículos y cubiertas" />
    ),
    '/administracion/flota-y-taller/modelos-de-articulos-y-cubiertas': (
      <EnConstruccion title="Modelos de artículos y cubiertas" />
    ),
    '/administracion/flota-y-taller/tipos-de-cubiertas': (
      <EnConstruccion title="Tipos de cubiertas" />
    ),
    '/administracion/flota-y-taller/familias-de-articulos-de-panol': (
      <EnConstruccion title="Familias de artículos de pañol" />
    ),
    '/administracion/flota-y-taller/tipos-de-novedades-para-unidades': (
      <EnConstruccion title="Tipos de novedades para unidades" />
    ),
    '/administracion/flota-y-taller/definicion-de-continentes': (
      <EnConstruccion title="Definición de continentes" />
    ),
    '/administracion/flota-y-taller/ubicaciones-por-deposito': (
      <EnConstruccion title="Ubicaciones por depósito" />
    ),
    '/administracion/flota-y-taller/articulos-por-cliente': (
      <EnConstruccion title="Artículos por cliente" />
    ),
    '/administracion/bancos-y-valores/bancos': <BancosPage />,
    '/administracion/bancos-y-valores/conceptos-bancarios': <ConceptosBancariosPage />,
    '/administracion/bancos-y-valores/retenciones-y-otros-valores': <RetencionesValoresPage />,
    '/administracion/afip-e-impuestos/importar-padron-arba-retenc-percepc': (
      <EnConstruccion title="Importar padrón ARBA - retenc/percepc" />
    ),
    '/administracion/afip-e-impuestos/importar-percepciones-ib-mendoza': (
      <EnConstruccion title="Importar percepciones IB Mendoza" />
    ),
    '/administracion/afip-e-impuestos/importar-padron-agip-retenc-percepc': (
      <EnConstruccion title="Importar padrón AGIP - retenc/percepc" />
    ),
    '/administracion/afip-e-impuestos/actualizar-porcentaje-percepcion-ib-mendoza': (
      <EnConstruccion title="Actualizar % de percepción IB Mendoza" />
    ),
    '/administracion/afip-e-impuestos/importacion-de-padron-de-morosos': (
      <EnConstruccion title="Importación de padrón de morosos" />
    ),
    '/administracion/afip-e-impuestos/diccionario-de-documentos-afip': (
      <EnConstruccion title="Diccionario de documentos AFIP" />
    ),
    '/administracion/afip-e-impuestos/certificados-de-factura-electronica': <AfipCredentialsPage />,
    '/administracion/afip-e-impuestos/tipos-de-documentos-de-identidad': (
      <EnConstruccion title="Tipos de documentos de identidad" />
    ),
    '/administracion/empresa/sucursales-de-la-empresa': <SucursalesEmpresaPage />,
    '/administracion/empresa/localidades-atendidas': <LocalidadesAtendidasPage />,
    '/administracion/empresa/rutas-de-distribucion': <RutasDistribucionPage />,
    '/administracion/empresa/plantilla-de-impresion-de-guias': <GuiaPrintTemplatePage />,
    '/administracion/empresa/correo-de-facturas': <InvoiceEmailSettingsPage />,
    '/administracion/redespachos': <EmpresasRedespachoPage />,
    '/administracion/redespachos/nuevo': <EmpresasRedespachoPage />,
    '/administracion/redespachos/:id': <EmpresasRedespachoPage />,
    '/administracion/empresa/comprobantes-habilitados': (
      <EnConstruccion title="Comprobantes habilitados" />
    ),
    '/administracion/empresa/numeracion-del-sistema': <NumeracionesPage />,
    '/administracion/empresa/puntos-de-venta': <PuntosVentaPage />,
  };

  const customRoutes = {
    '/configuracion/impresion': <ImpresionPage />,
    '/atencion/tickets': <TicketsPage />,
    '/atencion/sla': <SlaPage />,
    '/atencion/dashboard': <AtencionDashboardPage />,
    '/chat': <ChatPage />,
    '/portal/login': <PortalLoginPage />,
    '/portal/envios': <PortalEnviosPage />,
    '/portal/tickets/nuevo': <PortalTicketNuevoPage />,
    '/portal/tickets/detalle': <PortalTicketDetailPage />,
    '/cargas': <Navigate to="/cargas/dashboard" replace />,
    '/cargas/dashboard': <DashboardCargas />,
    '/cargas/documentacion-por-bolsa': <DocumentacionPorBolsa />,
    '/cargas/retornables': <RetornablesMonitor />,
    '/cargas/retornables/ubicaciones': <RetornablesMonitor />,
    '/cargas/retornables/nuevo': <RetornablesMonitor />,
    '/clientes': <ClientesList />,
    // Nuevo componente con pestañas para alta de cliente
    '/clientes/nuevo': <NuevoCliente />,
    '/clientes/:id/cuenta-corriente': <CuentaCorrienteCliente />,
    '/clientes/:id/retornables': <RetornablesMonitor />,
    '/clientes/:id/credito': <CreditoCliente />,
    '/finanzas/creditos': <CreditosDashboard />,
    '/finanzas/tarifarios': <TarifariosPage />,
    '/retiros': <RetirosPage />,
    '/administracion': <DashboardAdministracion />,
    '/administracion/dashboard': <Navigate to="/administracion" replace />,
    '/administracion/clientes': <ClientesList />,
    '/administracion/vehiculos': <Navigate to="/administracion/flota" replace />,
    '/administracion/vehiculos/nuevo': <Navigate to="/administracion/flota/nuevo" replace />,
    '/administracion/vehiculos/:id': <Navigate to="/administracion/flota" replace />,
    '/administracion/vehiculos/:id/editar': <Navigate to="/administracion/flota" replace />,
    '/administracion/choferes': <ListaChoferes />,
    '/administracion/choferes/nuevo': <CrearChofer />,
    '/administracion/choferes/:id': <VerChofer />,
    '/administracion/choferes/:id/editar': <EditarChofer />,
    '/administracion/flota': <ListadoUnidades />,
    '/administracion/unidades': <ListadoUnidades />,
    '/administracion/flota/nuevo': <FormularioUnidad />,
    '/administracion/flota/:id/editar': <FormularioUnidad />,
    '/administracion/flota/asignaciones': <ListadoAsignacionesFlota />,
    '/administracion/flota/asignaciones/nueva': <NuevaAsignacionFlota />,
    '/facturacion/manual': <Navigate to="/facturacion/manual/nueva" replace />,
    '/facturacion/manual/nueva': <FacturaManual />,
    '/facturacion': <FacturacionIndex />,
    '/facturacion/nueva': <FacturacionNueva />,
    '/facturacion/desde-guias': <FacturacionNueva />,
    '/facturacion/pendientes-contado': <FacturacionNueva />,
    '/facturacion/:id': <FacturaDetalle />,
    '/facturacion/facturas/emitir': <FacturacionNueva />,
    '/facturacion/facturas': <FacturacionIndex />,
    '/facturacion/configuracion': <FacturaPrintConfig />,
    '/admin/proveedores': <ListadoProveedores />,
    '/admin/proveedores/nuevo': <NuevoProveedor />,
    '/admin/proveedores/:id': <EditarProveedor />,
    '/admin/vehiculos': <Navigate to="/administracion/flota" replace />,
    '/admin/vehiculos/nuevo': <Navigate to="/administracion/flota/nuevo" replace />,
    '/admin/vehiculos/:id': <Navigate to="/administracion/flota" replace />,
    '/admin/vehiculos/:id/editar': <Navigate to="/administracion/flota" replace />,
    '/guias': <GuiasListado />,
    '/guias/consulta': <GuiasListado />,
    '/guias/emitir': <EmisionGuiaV3 />,
    '/guias/buscar': <GuiasBuscar />,
    '/tarifas': <TarifasPage />,
    '/cobranzas': <Navigate to="/tesoreria/minutas" replace />,
    '/cobranzas/minuta/abrir': <AbrirMinuta />,
    '/cobranzas/minuta/:id': <MinutaDetalle />,
    '/cobranzas/minuta/:id/cerrar': <CerrarMinuta />,
    '/fojas/emision': <EmisionFoja />,
    '/fojas/recepcion/:id': <RecepcionFoja />,
    '/hdr': <Navigate to="/cargas/fojas-de-ruta" replace />,
    '/hdr/emitir': <Navigate to="/fojas/emision" replace />,
    '/hdr/confirmar': <Navigate to="/cargas/confirmacion-de-despachos" replace />,
    '/recepcion': <RecepcionOperativa />,
    '/compras/proveedores': <ProveedoresPage />,
    '/compras/ordenes': <OrdenesPage />,
    '/compras/recepciones': <RecepcionesPage />,
    '/stock': <StockDashboardPage />,
    '/stock/dashboard': <StockDashboardPage />,
    '/stock/movimientos': <MovimientosPage />,
    '/stock/inventarios': <InventariosPage />,
    '/stock/kardex': <KardexPage />,
    '/stock/ubicaciones': <UbicacionesPage />,
    '/stock/transferencias': <MovimientosPage />,
    '/stock/consulta': <LegacyStockConsulta />,
    '/stock/entradas/nueva': <LegacyStockMovimientoForm type="entrada" />,
    '/stock/entradas': <LegacyStockMovimientos type="ENTRADA" />,
    '/stock/salidas/nueva': <LegacyStockMovimientoForm type="salida" />,
    '/stock/salidas': <LegacyStockMovimientos type="SALIDA" />,
    '/stock/traslados/nuevo': <LegacyStockMovimientoForm type="traslado" />,
    '/mantenimiento-flota': <MantenimientoFlotaListado />,
    '/mantenimiento-flota/nuevo': <MantenimientoFlotaFormulario />,
    '/mantenimiento-flota/:id/editar': <MantenimientoFlotaFormulario />,
    '/repartos': <RepartosListado />,
    '/repartos/nuevo': <RepartoNuevo />,
    '/repartos/estadisticas': <RepartosEstadisticas />,
    '/repartos/:id': <RepartoDetalle />,
    '/cargas/repartos': <RepartosListado />,
    '/cargas/repartos/nuevo': <RepartoNuevo />,
    '/cargas/repartos/:id': <RepartoDetalle />,
    '/cargas/etiquetas': <EtiquetasListado />,
    '/cargas/etiquetas/nueva': <EtiquetasNueva />,
    '/cargas/recepcion': <RecepcionList />,
    '/cargas/recepcion/nueva': <RecepcionWizard />,
    '/cargas/control-carga': <ControlCargaMonitor />,
    '/cargas/control-bultos': <ControlBultos />,
    '/cargas/recepcion/:id': <RecepcionDetalle />,
    '/cargas/novedades': <NovedadesPage />,
    '/cargas/retenidas': <NovedadesRetenidasPage />,
    '/cargas/correccion-novedades': <NovedadesPage />,
    '/administracion/etiquetas-zpl': <EtiquetasZpl />,
    '/tesoreria': <DashboardTesoreria />,
    '/tesoreria/dashboard': <DashboardTesoreria />,
    '/tesoreria/compras': <ListadoCompras />,
    '/tesoreria/compras/nueva': <NuevaCompra />,
    '/tesoreria/compras/carga-masiva': <CargaMasivaCompras />,
    '/tesoreria/compras/:id': <VerEditarCompra />,
    // Cuentas Bancarias
    '/tesoreria/cuentas': <ListadoCuentas />,
    '/Tesoreria/Cuentas': <ListadoCuentas />,
    '/Tesoreria/Cuentas/Nueva': <EditarCuenta />,
    '/Tesoreria/Cuentas/:id/Editar': <EditarCuenta />,
    '/Tesoreria/Cuentas/:id/Ver': <EditarCuenta />,
    // Medios de Pago
    '/tesoreria/mediospago': <ListadoMediosPago />,
    '/Tesoreria/MediosPago': <ListadoMediosPago />,
    '/Tesoreria/MediosPago/Nuevo': <EditarMedioPago />,
    '/Tesoreria/MediosPago/:id/Editar': <EditarMedioPago />,
    // Pagos
    '/tesoreria/pagos': <ListadoPagos />,
    '/tesoreria/cuentas-pagar': <CuentasAPagar />,
    '/tesoreria/minutas-pago': <MinutasPago />,
    '/Tesoreria/Pagos': <ListadoPagos />,
    '/Tesoreria/Pagos/Nuevo': <EditarPago />,
    '/Tesoreria/Pagos/:id': <EditarPago />,
    '/Tesoreria/Pagos/:id/Editar': <EditarPago />,
    // Cobranzas
    '/tesoreria/cobranzas': <ListadoCobranzas />,
    '/tesoreria/cobranzas/nueva': <RegistrarCobranza />,
    '/tesoreria/recibos': <ListadoRecibos />,
    '/tesoreria/recibos/:id': <ReciboDetalle />,
    '/tesoreria/cartera-cheques': <CarteraCheques />,
    '/tesoreria/minutas': <MinutasList />,
    '/tesoreria/minutas/:id': <MinutaUnificadaDetalle />,
    '/tesoreria/cobranzas/seguimiento-de-contrareembolsos-cobrados': <SeguimientoContrareembolsos />,
    '/tesoreria/contrareembolsos/:id': <ContrareembolsoDetalle />,
    '/Tesoreria/Cobranzas': <ListadoCobranzas />,
    '/Tesoreria/Cobranzas/Nueva': <RegistrarCobranza />,
    '/Tesoreria/Cobranzas/:id': <EditarCobranza />,
    '/Tesoreria/Cobranzas/:id/Editar': <EditarCobranza />,
    // Conciliaciones
    '/tesoreria/cajas': <CajasPage />,
    '/tesoreria/cajas/:id': <CajaDetallePage />,
    '/tesoreria/conciliaciones': <Conciliaciones />,
    '/tesoreria/conciliacion': <Conciliaciones />,
    '/tesoreria/choferes/liquidaciones': <LiquidacionesChoferesPage />,
    '/tesoreria/choferes/liquidaciones/:id': <LiquidacionChoferDetallePage />,
    '/Tesoreria/Conciliaciones': <Conciliaciones />,
    // Seguridad
    '/seguridad': <SeguridadHome />,
    '/seguridad/usuarios': <UsuariosList />,
    '/seguridad/usuarios/nuevo': <UsuarioSecurityForm />,
    '/seguridad/usuarios/:id': <UsuarioSecurityForm />,
    '/seguridad/roles': <RolesPermisosList />,
    '/seguridad/roles/nuevo': <RolSecurityForm />,
    '/seguridad/roles/:id': <RolSecurityForm />,
    '/seguridad/sesiones': <SesionesList />,
    '/seguridad/auditoria': <AuditoriaList />,
    // Administración - Usuarios
    '/administracion/usuarios': <Navigate to="/gerencial/usuarios" replace />,
    // Contabilidad
    '/contabilidad': <ContabilidadReportesPage />,
    '/contabilidad/cuentas': <ContabilidadCuentasPage />,
    '/contabilidad/centros': <ContabilidadCentrosPage />,
    '/contabilidad/asientos': <ContabilidadAsientosPage />,
    '/contabilidad/politicas': <ContabilidadPoliticasPage />,
    '/contabilidad/reportes': <ContabilidadReportesPage />,
    '/gerencial': <DashboardGerencial />,
    '/gerencial/dashboard': <DashboardGerencial />,
    '/finanzas/ejecutivo': <ExecutiveDashboardPage />,
    '/gerencial/alertas': <GerencialAlertasPage />,
    '/operaciones/alertas': <AlertasOperaciones />,
    '/operaciones/inteligencia': <InteligenciaOperativa />,
    '/operaciones/inteligencia/configuracion': <InteligenciaOperativaConfiguracion />,
    '/monitor/operaciones': <MonitorOperaciones />,
    '/gerencial/reportes': <GerencialReportesPage />,
    '/informes': <InformesDashboard />,
    '/informes/financieros': <ReportesGerenciales initialTab="finanzas" />,
    '/informes/productividad': <ReportesGerenciales initialTab="operacion" />,
    '/informes/clientes': <ReportesGerenciales initialTab="clientes" />,
    '/informes/choferes': <ReportesGerenciales initialTab="choferes" />,
    '/gerencial/configuracion/fojas': <FojasPoliticasPage />,
    '/gerencial/reportes-operativos': <DashboardOperativoReportesPage />,
    '/gerencial/alertas-operativas': <AlertasOperativasReportesPage />,
    '/gerencial/seguridad': <SeguridadHome />,
    '/gerencial/roles': <RolesPermisosList />,
    '/gerencial/roles/nuevo': <RolSecurityForm />,
    '/gerencial/roles/:id': <RolSecurityForm />,
    '/gerencial/usuarios': <UsuariosList />,
    '/gerencial/usuarios/nuevo': <UsuarioSecurityForm />,
    '/gerencial/usuarios/:id': <UsuarioSecurityForm />,
    '/gerencial/sesiones': <SesionesList />,
    '/gerencial/auditoria': <AuditoriaList />,
    '/app/cargas': <Navigate to="/cargas/dashboard" replace />,
    '/lineas': <ListadoLineas />,
    '/lineas/nueva': <NuevaLinea />,

    ...adminPlaceholderRoutes,

    ...clipperCargasRoutes,
    ...clipperTesoreriaRoutes,
    ...clipperCtasCtesRoutes,



    ...adminRouteEntries,
    ...guiaEntries,
    ...rrhhRouteEntries,
  };

  return (
    <Routes>
      <Route path="/" element={<Navigate to={isAuth ? '/cargas/dashboard' : '/login'} replace />} />

      {/* pública */}
      {authRoutes.map(route => (
        <Route key={route.path} path={route.path} element={<route.component />} />
      ))}
      <Route path="/activar" element={<TenantActivation />} />

      {/* privadas */}
      <Route element={<PrivateRoute />}>
        <Route element={<AppLayout />}>
          <Route index element={<Navigate to="/cargas/dashboard" replace />} />
          <Route path="/stock/ubicaciones" element={<RouteAccessGuard path="/stock/ubicaciones"><UbicacionesPage /></RouteAccessGuard>} />
          {routes.map(r => (
            <Route
              key={r.path}
              path={r.path}
              element={<RouteAccessGuard path={r.path}>{customRoutes[r.path] || <Placeholder title={r.label || r.path} />}</RouteAccessGuard>}
            />
          ))}
        </Route>
      </Route>

      {/* fallback */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
